import { Grid } from "@mui/material";
import Close from "../../assets/Close.svg";
import MirrorOfficialFanClubLogo from "../../assets/MirrorOfficialFanClubLogo.svg";
import CommonText from "../../components/common/typographies/CommonText";
import CommonFormTextField from "../../components/common/textfields/FormTextField";
import CommonEmailTextField from "../../components/common/textfields/EmailTextField";
import WhiteButton from "../../components/common/buttons/WhiteButton";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CircularProgress } from "@mui/material";

function MiroValidation({ onClose, onSubmit }) {
  const { t, i18n } = useTranslation("miroValidation");
  const [errors, setErrors] = useState({});
  const [value, setValue] = useState({});
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState("");

  const handleOnClickSubmit = () => {
    if (!value.memberNumber || !value.email) {
      setErrors((prevState) => {
        let e = {};
        if (!value.memberNumber) {
          e["memberNumber"] = "incorrectInput";
        }
        if (!value.email) {
          e["email"] = "incorrectInput";
        }
        return e;
      });
    } else {
      console.log("value", value);
      setLoading(true);
      onSubmit &&
        onSubmit({
          value,
          onError: (errorMsg) => {
            setApiError(errorMsg);
            setLoading(false);
          },
        });
    }
  };

  const handleOnChange = (e) => {
    setValue({ ...value, [e.target.name]: e.target.value.trim() });
    setErrors((prevState) => {
      let clone = { ...prevState };
      if (clone[e.target.name]) {
        delete prevState[e.target.name];
      }
      return clone;
    });
    setApiError("");
  };

  return (
    <Grid
      container
      direction="column"
      style={{ height: "100%", flexWrap: "nowrap" }}
    >
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        style={{ padding: 30 }}
      >
        <CommonText fontSize="18px" lineHeight="26px" fontWeight="700">
          {t("miroValidation")}
        </CommonText>
        <img
          src={Close}
          alt="Close"
          style={{ cursor: "pointer" }}
          onClick={onClose}
        />
      </Grid>
      <Grid
        item
        xs
        container
        direction="column"
        style={{ padding: `0px 30px 20px 30px`, flexWrap: "nowrap" }}
      >
        <Grid
          item
          container
          justifyContent="center"
          alignItems="center"
          style={{ margin: `10px 0px 30px 0px` }}
        >
          <img
            src={MirrorOfficialFanClubLogo}
            alt="MirrorOfficialFanClubLogo"
          />
        </Grid>
        <Grid item xs>
          <CommonText
            fontSize="18px"
            lineHeight="28px"
            fontWeight="700"
            style={{ marginBottom: 10 }}
          >
            {t("desc1")}
          </CommonText>
          <CommonText
            fontSize="16px"
            lineHeight="24px"
            fontWeight="400"
            style={{ marginBottom: 20 }}
          >
            {t("desc2")}
          </CommonText>

          <Grid item style={{ marginBottom: 30 }}>
            <CommonText>{t("field.memberNumber")}</CommonText>
            <CommonFormTextField
              errorText={
                errors.memberNumber && t(`error.${errors.memberNumber}`)
              }
              name="memberNumber"
              onChange={handleOnChange}
            />
          </Grid>

          <Grid item style={{ marginBottom: 30 }}>
            <CommonText>{t("field.email")}</CommonText>
            <CommonFormTextField
              errorText={errors.email && t(`error.${errors.email}`)}
              name="email"
              onChange={handleOnChange}
            />
          </Grid>
        </Grid>
        <CommonText
          color="#F44434"
          fontSize="16px"
          lineHeight="24px"
          fontWeight="400"
        >
          {apiError}
        </CommonText>
        <Grid item>
          <WhiteButton fullWidth onClick={handleOnClickSubmit}>
            {loading ? (
              <CircularProgress size={20} style={{ marginLeft: 6 }} />
            ) : (
              t("button.confirm")
            )}
          </WhiteButton>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default MiroValidation;
